import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CampaignsTab = ({ showToast }) => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        const res = await axios.get('/api/meta/campaigns', {
          headers: { Authorization: `Bearer ${localStorage.getItem('crm_token')}` }
        });
        setCampaigns(res.data || []);
      } catch (err) {
        console.error(err);
        showToast('Kampanyalar yüklenirken hata oluştu', 'error');
      } finally {
        setLoading(false);
      }
    };
    fetchCampaigns();
  }, [showToast]);

  if (loading) return <div style={{ textAlign: 'center', padding: '40px', color: 'var(--text-muted)' }}>Yükleniyor...</div>;

  return (
    <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
      <div style={{ padding: '20px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0, fontSize: '16px', color: 'var(--text)' }}>Tüm Kampanyalar</h3>
        <span style={{ fontSize: '13px', color: 'var(--text-muted)' }}>Toplam {campaigns.length} kampanya</span>
      </div>

      <div className="table-container" style={{ border: 'none', borderRadius: 0 }}>
        <table className="table">
          <thead>
            <tr>
              <th>Kampanya Adı</th>
              <th>Durum</th>
              <th>Harcama</th>
              <th>Erişim</th>
              <th>Leadler</th>
              <th>Mesaj</th>
            </tr>
          </thead>
          <tbody>
            {campaigns.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ padding: '40px', textAlign: 'center', color: 'var(--text-muted)' }}>Henüz kampanya verisi yok. Senkronizasyon yapmayı deneyin.</td>
              </tr>
            ) : (
              campaigns.map(camp => (
                <tr key={camp.id}>
                  <td>
                    <div style={{ fontWeight: '500', color: 'var(--text)' }}>{camp.name}</div>
                    <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>{camp.objective || 'Bilinmiyor'}</div>
                  </td>
                  <td>
                    <span className={`badge ${camp.status === 'ACTIVE' ? 'badge-success' : 'badge-gray'}`}>
                      {camp.status}
                    </span>
                  </td>
                  <td style={{ fontWeight: '500' }}>₺{parseFloat(camp.spend || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</td>
                  <td>{parseInt(camp.reach || 0).toLocaleString('tr-TR')}</td>
                  <td style={{ fontWeight: '500', color: 'var(--primary)' }}>{camp.leads}</td>
                  <td style={{ fontWeight: '500', color: '#00c2ff' }}>{camp.messages || 0}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CampaignsTab;
